import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import * as s from "./Navbar/index.module.scss";

const Layout = ({ children, data }) => {
  const [toggle, setToggle] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const updateWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth);

    return () => {
      window.removeEventListener("resize", updateWindowWidth);
    };
  }, []);

  const isDesktop = windowWidth > 1024;

  return (
    <>
      <div
        className={`${!isDesktop ? "overflow-hidden" : ""} ${
          expanded ? s.expanded : ""
        }`}
      >
        <Navbar
          toggle={toggle}
          setToggle={setToggle}
          expanded={expanded}
          setExpanded={setExpanded}
        />
        <main
          onClick={() => {
            setToggle(false);
          }}
        >
          {children}
        </main>
        <Footer data={data} />
      </div>
    </>
  );
};

export default Layout;
